<template>
  <div class="app-container">
    <el-table
      max-height="700"  v-loading="listLoading" 
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="dataList"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column type="selection" width="55"> </el-table-column>

      <el-table-column label="序号" width="95">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
          <!-- {{ ( screen.page - 1) * screen.page_size + scope.$index + 1 }} -->
        </template>
      </el-table-column>
      <el-table-column label="园区">
        <template>
          <span>三深国际中心</span>
        </template>
      </el-table-column>
      <el-table-column label="缴费人">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="手机号">
        <template slot-scope="scope">
          {{ scope.row.phone }}
        </template>
      </el-table-column>
      <el-table-column label="车牌">
        <template slot-scope="scope">
          {{ scope.row.cp }}
        </template>
      </el-table-column>
      <el-table-column label="实付价格">
        <template slot-scope="scope">
          {{ scope.row.pic }}
        </template>
      </el-table-column>
      <el-table-column label="承租类型">
        <template slot-scope="scope">
          {{ scope.row.end_time }}
        </template>
      </el-table-column>
      <el-table-column label="缴费类型">
        <template> 临时停车缴费 </template>
      </el-table-column>
      <el-table-column label="缴费时间">
        <template slot-scope="scope">
          {{ scope.row.time }}
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      layout="total, sizes, prev, pager, next, jumper"
      :total="10"
      style="margin-top: 10px"
    >
    </el-pagination>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Editor from "@/components/Editor";
import {
  callerLists,
  addBanner,
  bannerDetail,
  editBanner,
  delBanner,
  openPark,
  delImage,
} from "@/api/index";
import { getToken } from "@/utils/auth";
export default {
  components: { Editor },
  computed: {
    ...mapGetters(["roles", "userInfo"]),
  },
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger",
      };
      return statusMap[status];
    },
  },
  data() {
    return {
      token: getToken(),
      list: [],
      listLoading: true,
      drawer: false,
      drawerTitle: "添加",
      screen: {
        page: 1,
        page_size: 15,
        phone: "",
        visitor_name: "",
        visitor_phone: "",
        park_id: "",
      },
      total: 0,
      multipleSelection: [],
      cztype: "",
      parkList: [],
      nameArr: [
        "张三",
        "李四",
        "王小虎",
        "李明",
        "刘子扬",
        "郑华",
        "李明",
        "刘子扬",
        "郑华",
        "王小虎",
      ],
      dataList: [],
    };
  },
  created() {
    // if (this.userInfo.park_id !== 0) {
    //   this.screen.park_id = this.userInfo.park_id;
    // } else {
    //   this.screen.park_id = "";
    // }
    // this.fetchData();
    // this.getPark();
    this.suiji();
  },
  methods: {
    suiji() {
      for (var i = 0; i < 10; i++) {
        this.dataList.push({
          time: "2023-03-25 11:13:16",
          dd: Math.round(Math.random() * 10) + "号闸机",
          pic: Math.round(Math.random() * 10).toFixed(2),
          name: this.nameArr[
            parseInt(Math.random() * (this.nameArr.length - 1 + 1) + 1)
          ],
          type: "月",
          phone: this.getMoble(),
          cp: "浙F15GH7",
        });
      }

      this.listLoading = false;
    },
    getMoble() {
      var prefixArray = new Array(
        "130",
        "131",
        "132",
        "133",
        "135",
        "137",
        "138",
        "170",
        "187",
        "189"
      );

      var i = parseInt(10 * Math.random());

      var prefix = prefixArray[i];

      for (var j = 0; j < 8; j++) {
        prefix = prefix + Math.floor(Math.random() * 10);
      }

      return prefix;
    },
    reset() {
      this.screen = {
        phone: "",
        visitor_name: "",
        visitor_phone: "",
        park_id: "",
        page: 1,
        page_size: 15,
      };
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    // 修改
    editForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleForm.park_ids = this.ruleForm.park_ids.toString();
          this.$confirm("确认提交？")
            .then((_) => {
              editBanner(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                message: res.msg,
                type: "success",
              });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch((_) => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 编辑
    handleEdit(val) {
      this.cztype = "edit";
      this.drawerTitle = "编辑";
      this.getInfo(val.id);
      // this.drawer = true;
    },
    // 查看
    handleSee(val) {
      this.cztype = "see";
      this.drawerTitle = "查看";
      // this.ruleForm = val
      this.getInfo(val.id);
      // this.drawer = true;
    },
    // 获取信息
    getInfo(id) {
      var that = this;
      bannerDetail({ id: id }).then((res) => {
        // this.domains = res.data.company_role_data
        this.ruleForm = {
          id: res.data.info.id,
          thumb: res.data.info.thumb,
          park_ids: res.data.info.park_ids.split(",").map(Number),
          status: res.data.info.status,
          sort: res.data.info.sort,
          is_jump: res.data.info.is_jump,
          jump_url: res.data.info.jump_url,
        };
      });
      this.drawer = true;
    },
    // 删除
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleForm.park_ids = this.ruleForm.park_ids.toString();
          if (this.ruleForm.is_jump == 0) {
            this.ruleForm.jump_url = "";
          }
          this.$confirm("确认提交？")
            .then((_) => {
              addBanner(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                message: res.msg,
                type: "success",
              });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch((_) => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate();
          });
          done();
        })
        .catch((_) => {});
    },
    addMenu(id) {
      this.drawerTitle = "添加";
      this.cztype = "add";
      this.ruleForm = {
        park_ids: [],
        thumb: "",
        status: 1,
        sort: "",
        is_jump: 0,
        jump_url: "",
      };
      if (this.userInfo.park_id !== 0) {
        this.ruleForm.park_ids.push(this.userInfo.park_id);
      }
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate();
      });
      this.drawer = true;
    },
    // 获取园区
    getPark() {
      this.parkList = [];
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
      this.drawer = false;
    },
    fetchData() {
      this.listLoading = true;
      callerLists(this.screen).then((response) => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}

.table-box {
  margin-top: 20px;
}
.avatar-uploader {
  width: 80px;
  height: 80px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 90px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.screenInput {
  width: 200px;
  margin: 0 10px;
}
.w4 {
  width: 40%;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
</style>
